import { Component, OnInit, ViewChild, AfterViewInit, ElementRef, EventEmitter, Output } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { GlobalSearchService } from '../../../services/globalsearchservice.service'
import { PrintService } from '../../../services/print.service'
import { VendorService } from '../../../services/vendor.service'
import { trigger, state, style, transition, animate , query, group, stagger } from '@angular/animations';

@Component({
	selector: 'app-vendordash-overdue',
	templateUrl: './vendordash-overdue.component.html',
	styleUrls: ['./vendordash-overdue.component.scss'],
	animations: [
	  trigger('flipState', [
		  state('active', style({
			  transform: 'rotate3d(0, 1, 0, 179deg)',
		  })),
		  state('inactive', style({
			  transform: 'rotateY(0)'
		  })),
		  transition('active => inactive', animate('500ms ease-out')),
		  transition('inactive => active', animate('500ms ease-in')),
	  ]),
	]
})
export class VendordashOverdueComponent implements OnInit {

	flip = 'inactive';
	@Output() viewData = new EventEmitter<any>();

	aged: any = [];
	aged30: any = [];
	aged60: any = [];
	aged90: any = [];
	original_aged: any = [];

	total_overdue_details = {
		thirty: 0,
		sixty: 0,
		ninety: 0,
		total: 0,
	}

	viewing: any = false;
	title: any = '';
	sending = false;
	pdf = false;
	paginator_show = true;
	@ViewChild('print_table') printtable: ElementRef;

	constructor(private globalSearchService: GlobalSearchService, private printService: PrintService, private vendorService: VendorService) {

	}

	ngOnInit(): void {
		this.vendorService.getDashBoard().subscribe((results: any) => {
			if (results && results.aged) {
				this.aged = results.aged;
				this.original_aged = results.aged;

				// Filter by aging buckets
				this.aged30 = this.aged.filter((v: any) => {
					return parseFloat(v.due) > 0.0000;
				});

				this.aged60 = this.aged.filter((v: any) => {
					return parseFloat(v.overdue1) > 0.0000 && parseFloat(v.due) <= 0.0000;
				});

				this.aged90 = this.aged.filter((v: any) => {
					return parseFloat(v.overdue2) > 0.0000 && parseFloat(v.overdue1) <= 0.0000;
				});

				// Calculate totals
				if (Array.isArray(this.aged)) {
					this.total_overdue_details.thirty = this.aged.reduce((acc: number, v: any) => {
						return acc + (parseFloat(v.due) > 0.0000 ? 1 : 0);
					}, 0);

					this.total_overdue_details.sixty = this.aged.reduce((acc: number, v: any) => {
						return acc + (parseFloat(v.overdue1) > 0.0000 && parseFloat(v.due) <= 0.0000 ? 1 : 0);
					}, 0);

					this.total_overdue_details.ninety = this.aged.reduce((acc: number, v: any) => {
						return acc + (parseFloat(v.overdue2) > 0.0000 && parseFloat(v.overdue1) <= 0.0000 ? 1 : 0);
					}, 0);
				}

				this.total_overdue_details.total = this.total_overdue_details.thirty + this.total_overdue_details.sixty + this.total_overdue_details.ninety;
			}
		});
	}

	toggleFlip(data: any, title: string) {
		if (!data) {
			this.flip = 'inactive';
		} else {
			this.flip = (this.flip == 'active') ? 'inactive' : 'active';
		}

		if (this.flip == 'active') {
			this.viewing = data;
			this.title = title;
			const dashboard_data = { data: data, title: 'Over Due Vendors' };
			this.viewData.emit(dashboard_data);
		} else {
			this.viewing = false;
			this.viewData.emit(false);
		}
	}

	exportPdf() {
		this.sending = true;
		this.paginator_show = false;
		const encoded: string = this.globalSearchService.base64encode(this.printtable.nativeElement.innerHTML);
		const today = new Date();
		const data = {
			content: encoded,
			filename: 'overdue-vendors.pdf',
			landscape: true,
			title: 'Over Due Vendors',
			subtitle: 'Created ' + today.toLocaleString()
		};
		this.printService.pdf(data).subscribe((result: any) => {
			this.globalSearchService.downloadPdf(result.content, data.filename);
			this.sending = false;
			this.paginator_show = true;
		});
	}

	exportXls() {
		this.sending = true;
		const encoded: string = this.globalSearchService.base64encode(this.printtable.nativeElement.innerHTML);
		const today = new Date();
		const data = {
			content: encoded,
			filename: 'overdue-vendors.xlsx',
			title: 'Over Due Vendors',
			subtitle: 'Created ' + today.toLocaleString()
		};
		this.printService.xls(data).subscribe((result: any) => {
			this.globalSearchService.downloadXls(result.content, data.filename);
			this.sending = false;
		});
	}

}
